import { FormikProps } from 'formik'
import React from 'react'
import styled from 'styled-components'
import { Button } from 'sutra/components/Button'
import { FormItem } from 'sutra/components/Form'

import { Loader } from 'components'
import { CardNew } from 'features/project-form/components/CardNew'
import ProjectSourceVirtualizedList from 'features/project-form/components/ProjectSourceVirtualizedList'
import { FormAdditionalValues } from 'features/project-form/types'

type Props = {
  title?: string
  isLoading: boolean
  handleOpenSource: () => void
  handleOpenProduct: () => void
  formik: FormikProps<FormAdditionalValues>
  setSourceToEditIndex: (n: number) => void
  setProductToEditIndex: (n: number) => void
}

export const EditProject: React.FC<Props> = ({
  title,
  formik,
  isLoading,
  handleOpenProduct,
  handleOpenSource,
  setSourceToEditIndex,
  setProductToEditIndex,
}) => {
  return (
    <Wrapper>
      <Title>{title}</Title>
      <HorizontalContainer>
        <div style={{ flexGrow: 2 }}>
          <Section>
            <FormItem
              label="Products"
              style={{ width: '100%', marginBottom: 0 }}
            >
              <div style={{ display: 'flex' }}>
                <Sources>
                  <SourceCardWrapper onClick={handleOpenProduct}>
                    <CardNew text={'Add Product'} />
                  </SourceCardWrapper>
                </Sources>
                <ProjectSourceVirtualizedList
                  items={formik.values.products}
                  handleOpen={handleOpenProduct}
                  setEditIndex={setProductToEditIndex}
                  formik={formik}
                />
              </div>
            </FormItem>
          </Section>
          <Section>
            <FormItem
              label="Sources"
              validateStatus={formik.errors.sources ? 'error' : ''}
              help={formik.errors.sources as React.ReactNode}
              style={{ width: '100%', marginBottom: 0 }}
            >
              <div style={{ display: 'flex' }}>
                <Sources>
                  <SourceCardWrapper onClick={handleOpenSource}>
                    <CardNew />
                  </SourceCardWrapper>
                </Sources>
                <ProjectSourceVirtualizedList
                  items={formik.values.sources}
                  handleOpen={handleOpenSource}
                  setEditIndex={setSourceToEditIndex}
                  formik={formik}
                />
              </div>
            </FormItem>
          </Section>
        </div>
        <div>
          <FormItem style={{ marginTop: 'auto', marginBottom: 0 }}>
            <SubmitButton
              variant="primary"
              type="submit"
              onClick={formik.submitForm}
              disabled={!formik.isValid || formik.isSubmitting}
            >
              Create
            </SubmitButton>
          </FormItem>
        </div>
      </HorizontalContainer>
      {isLoading && (
        <Overlay>
          <Loader />
        </Overlay>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 800px;
  max-height: 80vh;
  overflow: auto;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 1024px) {
    width: auto;
    min-width: 300px;
  }
`
const Sources = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: wrap;
  position: relative;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`
const SourceCardWrapper = styled.div`
  width: 100%;
  height: 150px;
  padding: 10px;
  display: flex;

  @media screen and (max-width: 1024px) {
    width: 100%;
  }
`
const SubmitButton = styled(Button)`
  display: flex;
  width: fit-content;
  margin: var(--default-padding) auto 0;
`
const Title = styled.h1`
  text-align: center;
`
const Overlay = styled.div`
  background: rgba(255, 255, 255, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Section = styled.div`
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px 16px;
  margin-bottom: 16px;
`

const HorizontalContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
`
